export const goAi = () => {
  let itDify = '//it.talkweb.com.cn/idaas/login?client_id=1983369607777402881&response_type=code&redirect_uri=https%3A%2F%2Faipro.talkweb.com.cn%2F%23%2FloginRedirect'
  // 从域名判断环境
  switch (location.host) {
    case 'uat.talkweb.com.cn':
      itDify = '//uat.talkweb.com.cn/idaas/login?client_id=1983368748664745986&response_type=code&redirect_uri=https%3A%2F%2Faiuat.talkweb.com.cn%2F%23%2FloginRedirect'
      break
    case 'armsit.talkweb.com.cn':
      itDify = '//armsit.talkweb.com.cn/idaas/login?client_id=1972591948841263105&response_type=code&redirect_uri=https%3A%2F%2Faisit.talkweb.com.cn%2F%23%2FloginRedirect'
      break
    case 'it.dev-paas.talkweb.com.cn':
      itDify = '//it.dev-paas.talkweb.com.cn/idaas/login?client_id=1983003458125365250&response_type=code&redirect_uri=https%3A%2F%2Faidev.talkweb.com.cn%2F%23%2FloginRedirect'
      break
  }
  window.open(location.protocol + itDify)
}

// http://it.dev-paas.talkweb.com.cn/idaas/login?client_id=1983003458125365250&response_type=code&redirect_uri=https%3A%2F%2Faidev.talkweb.com.cn%2F%23%2FloginRedirect

// http://armsit.talkweb.com.cn/idaas/login?client_id=1972591948841263105&response_type=code&redirect_uri=https%3A%2F%2Faisit.talkweb.com.cn%2F%23%2FloginRedirect

// https://uat.talkweb.com.cn/idaas/login?client_id=1983368748664745986&response_type=code&redirect_uri=https%3A%2F%2Faiuat.talkweb.com.cn%2F%23%2FloginRedirect

// https://it.talkweb.com.cn/idaas/login?client_id=1983369607777402881&response_type=code&redirect_uri=https%3A%2F%2Faipro.talkweb.com.cn%2F%23%2FloginRedirect
